namespace $ {
	const $shm_hitalama_map_access_envelope_hmac = { name: 'HMAC', hash: 'SHA-256' }
	const $shm_hitalama_map_access_envelope_sign = [ 'sign' ] as KeyUsage[]

	/** Private payload within a publicly readable, CRDT-signed registry. */
	export class $shm_hitalama_map_access_envelope extends $mol_object {

		@ $mol_mem_key
		static slot( [ auth, peer, map ]: readonly [ $giper_baza_auth, $giper_baza_auth_pass, string ] ) {
			// A public hash of map ID would still expose recipient→map links.
			// Both parties derive the same private slot; outsiders cannot guess it.
			const secret = auth.secret_mutual( peer )
			const raw = $mol_wire_sync( secret ).asArray()
			const subtle = this.$.$mol_crypto_native.subtle
			const key = $mol_wire_sync( subtle ).importKey( 'raw', raw, $shm_hitalama_map_access_envelope_hmac, false, $shm_hitalama_map_access_envelope_sign )
			const body = $mol_wire_sync( this.$ ).$mol_charset_encode( 'map-access:v1:slot:' + map )
			const signed = $mol_wire_sync( subtle ).sign( 'HMAC', key, body )
			return this.$.$giper_baza_link.from_bin( new Uint8Array( signed ).slice( 0, 6 ) )
		}

		@ $mol_mem_key
		static seal( [ auth, recipient, body ]: readonly [ $giper_baza_auth, $giper_baza_auth_pass, string ] ) {
			if( body.length > 4096 ) $mol_fail( new Error( 'Map invitation is too large' ) )
			const secret = auth.secret_mutual( recipient )
			// Preserve every buffer identity when encryption suspends and replays.
			const nonce = $mol_wire_sync( this.$ ).$mol_crypto2_nonce()
			const opened = $mol_wire_sync( this.$ ).$mol_charset_encode( body )
			const closed = $mol_wire_sync( secret ).encrypt( opened, nonce )
			const packed = new Uint8Array( nonce.length + closed.length )
			packed.set( nonce )
			packed.set( closed, nonce.length )
			return '1:' + this.$.$mol_base64_url_encode( packed )
		}

		@ $mol_mem_key
		static parts( packed: string ) {
			if( !packed.startsWith( '1:' ) || packed.length > 24_000 ) $mol_fail( new Error( 'Unsupported map invitation envelope' ) )
			const bytes = this.$.$mol_base64_url_decode( packed.slice( 2 ) )
			if( bytes.length < 32 || bytes.length % 16 ) $mol_fail( new Error( 'Invalid map invitation envelope' ) )
			return { nonce: bytes.slice( 0, 16 ), closed: bytes.slice( 16 ) }
		}

		@ $mol_mem_key
		static open( [ auth, signer, packed ]: readonly [ $giper_baza_auth, $giper_baza_auth_pass, string ] ) {
			const { nonce, closed } = this.parts( packed )
			const secret = auth.secret_mutual( signer )
			const opened = $mol_wire_sync( secret ).decrypt( closed, nonce )
			return this.$.$mol_charset_decode( opened )
		}

	}

}
